/*
 * @Author: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @Date: 2023-11-27 11:09:58
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-04 16:20:40
 * @FilePath: /front-vps-admin/src/web-framework/api/datadic.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const DatadicAPI = {
    getDatadic(service, datadicName, fields) {
        return Request.post(`/${service}/datadic/${datadicName}`, { fields: fields });
    }
};
export default DatadicAPI;